import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  activeStatus: {
    color: theme.palette.success.main,
    textTransform: 'capitalize',

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  switchLabel: {
    marginLeft: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  description: {
    maxWidth: '30rem',
  },
}));

export default useStyles;
